import { Link } from "react-router-dom";
import { villes } from "@/data/villes";
import { links } from "@/components/Header";

const FooterColumn = ({ title, children }) => (
  <div>
    <p className="text-xs font-semibold uppercase tracking-[0.25em] text-argia-gold">{title}</p>
    {children}
  </div>
);

const footerLink = "w-fit text-sm text-[#FDFBF7]/70 transition-colors hover:text-argia-gold";

export const Footer = () => (
  <footer className="bg-argia-ink text-[#FDFBF7]" data-testid="footer">
    <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 sm:grid-cols-2 lg:grid-cols-4 lg:px-10">
      <div>
        <div className="inline-block rounded-xl bg-[#FDFBF7] px-4 py-3">
          <img src="/assets/logo-argia-wide.png" alt="ARGIA Admin" className="h-14 w-auto" />
        </div>
        <p className="mt-5 max-w-xs text-sm leading-relaxed text-[#FDFBF7]/70">
          Gestionnaire administrative indépendante au Pays Basque, franchisée du réseau national AADPROX.
        </p>
        <p className="mt-6 text-xs font-semibold uppercase tracking-[0.25em] text-argia-gold">Franchisée du réseau</p>
        <a
          href="https://www.aadprox.com"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-3 inline-block rounded-xl bg-[#FDFBF7] px-6 py-4"
          data-testid="footer-aadprox-link"
        >
          <img src="/assets/logo-aadprox-wide.png" alt="AADPROX — réseau national d'accompagnement administratif" className="h-16 w-auto" data-testid="footer-aadprox-logo" />
        </a>
      </div>

      <FooterColumn title="Navigation">
        <div className="mt-4 flex flex-col gap-2">
          {[...links, { to: "/rendez-vous", label: "Rendez-vous" }].map((l) => (
            <Link key={l.to} to={l.to} className={footerLink}>{l.label}</Link>
          ))}
        </div>
      </FooterColumn>

      <FooterColumn title="Zones d'intervention">
        <div className="mt-4 flex flex-col gap-2" data-testid="footer-villes">
          {villes.map((v) => (
            <Link key={v.slug} to={v.path} data-testid={`footer-ville-${v.slug}`} className={footerLink}>
              Gestion administrative à {v.name}
            </Link>
          ))}
        </div>
      </FooterColumn>

      <FooterColumn title="Contact">
        <p className="mt-4 text-sm text-[#FDFBF7]/70">
          <a href="tel:+33633837456" data-testid="footer-phone" className="transition-colors hover:text-argia-gold">06 33 83 74 56</a>
          <br />
          <a href="mailto:a.violet@aadprox.com" data-testid="footer-email" className="transition-colors hover:text-argia-gold">a.violet@aadprox.com</a>
        </p>
        <p className="mt-4 text-sm leading-relaxed text-[#FDFBF7]/70">
          Pays Basque, Sud Landes et Béarn des Gaves. Sur site ou à distance.
        </p>
      </FooterColumn>
    </div>

    <div className="border-t border-white/10 px-6 py-5">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 text-xs text-[#FDFBF7]/50 sm:flex-row">
        <p>© {new Date().getFullYear()} ARGIA Admin — Aurélie Violet. Tous droits réservés.</p>
        <div className="flex items-center gap-5">
          <Link to="/mentions-legales" data-testid="footer-link-legal" className="transition-colors hover:text-argia-gold">Mentions légales</Link>
          <Link to="/politique-confidentialite" data-testid="footer-link-privacy" className="transition-colors hover:text-argia-gold">Confidentialité</Link>
          <Link to="/admin/login" data-testid="footer-link-admin" className="transition-colors hover:text-argia-gold">Espace pro</Link>
        </div>
      </div>
    </div>
  </footer>
);
